import axios from "axios";

if (process.env.REACT_APP_API_LINK.includes("localhost")) {
  axios.defaults.baseURL = process.env.REACT_APP_API_LINK;
} else {
  axios.defaults.baseURL =
    // `https://web-cors-everywhere.fly.dev/` + process.env.REACT_APP_API_LINK;
    process.env.REACT_APP_API_LINK;
}
axios.defaults.headers = {
  // Authorization: REACT_APP_API_AUTHORIZATION_KEY,
  "Content-Type": "application/json",
};

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export default axios;
